import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ListGroupState } from '@usf/ngrx-list';

@Component({
  selector: 'app-no-products-in-group',
  templateUrl: './no-products-in-group.component.html',
  styleUrls: ['./no-products-in-group.component.scss'],
})
export class NoProductsInGroupComponent {
  @Input() listCount: number;
  @Input() itemsLeftAfterFilter: number;
  @Input() isEditableList: boolean;
  @Input() isMobile: boolean;
  @Input() isListManagement: boolean;

  @Output() addProductActionEmitter: EventEmitter<any> = new EventEmitter();

  constructor() {}

  onAddProductAction() {
    this.addProductActionEmitter.emit();
  }
}
